import React from 'react';
import { Outlet } from 'react-router-dom';
import { GreetingsModalProvider } from '../../context/GreetingsModalProvider';

const PublicLayout = () => {
  return (
    <div className='public-container grow'>
      <GreetingsModalProvider>
        <Outlet />
      </GreetingsModalProvider>
    </div>
  );
};

export { PublicLayout };
